import { render } from "./FeaturesContent.vue?vue&type=template&id=ee827580&scoped=true&ts=true"
import script from "./FeaturesContent.vue?vue&type=script&lang=ts"
export * from "./FeaturesContent.vue?vue&type=script&lang=ts"

import "./FeaturesContent.vue?vue&type=style&index=0&id=ee827580&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee827580"]])

export default __exports__